export var PeerConnectionEvents;
(function (PeerConnectionEvents) {
    PeerConnectionEvents["ReceivedTrack"] = "receivedTrack";
    PeerConnectionEvents["ReceivedDCMessage"] = "receivedDCMessage";
    PeerConnectionEvents["ConnectionFailed"] = "connectionFailed";
})(PeerConnectionEvents || (PeerConnectionEvents = {}));
